var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CURRENTCOLOR",
    d: "m18.125 17.24-4.72-4.72a6.886 6.886 0 1 0-.884.884l4.72 4.72zM2.5 8.124a5.625 5.625 0 1 1 5.625 5.625A5.63 5.63 0 0 1 2.5 8.124"
  })));
};
export default SvgSearch;